import i18n from '@/utils/i18n';
import React from 'react';
import { Button, ModalSheet } from '@usepepper/sprout-kit-ui';
import { CheckInReminderContent } from '@/experiences/sales-portal/domain/accounts/screens/account-detail/containers/account-detail-check-in/components/check-in-reminder-content';
import { DateTimeSelection } from '@/experiences/sales-portal/blocs/utils/date-picker-calendar-utils';
import { useDateTimePicker } from '@/experiences/sales-portal/blocs/hooks/use-date-time-picker';

interface CheckInReminderSheetProps {
  onClose: () => void;
  onInvalidTime: () => void;
  onSetReminder: (reminder?: DateTimeSelection) => void;
  open: boolean;
  reminder?: DateTimeSelection;
}

export const CheckInReminderSheet: React.FC<CheckInReminderSheetProps> = ({
  onClose,
  onInvalidTime,
  onSetReminder,
  open,
  reminder,
}) => {
  const {
    clear,
    getValidSelection,
    handleDateChange,
    handleTimeChange,
    isSelectionValid,
    selectedDate,
    selectedTime,
  } = useDateTimePicker(reminder);
  const title = i18n.t('sales_portal.activity_note.reminder.set_reminder');
  const canSave = selectedDate ? isSelectionValid : Boolean(reminder);

  const handleSave = () => {
    if (!selectedDate) {
      onSetReminder(undefined);
      onClose();
      return;
    }

    const selection = getValidSelection();

    if (!selection) {
      return;
    }

    onSetReminder(selection);
    onClose();
  };

  return (
    <ModalSheet
      aria-label={title}
      onOpenChange={(next) => {
        if (!next) {
          onClose();
        }
      }}
      open={open}
    >
      <ModalSheet.Header closeLabel={i18n.t('close')}>
        <ModalSheet.Title>{title}</ModalSheet.Title>
      </ModalSheet.Header>
      <ModalSheet.Body>
        <CheckInReminderContent
          onDateChange={handleDateChange}
          onInvalidTime={onInvalidTime}
          onTimeChange={handleTimeChange}
          selectedDate={selectedDate}
          selectedTime={selectedTime}
        />
      </ModalSheet.Body>
      <ModalSheet.Footer>
        <Button flex={1} onPress={clear} size="$lg" variant="secondary">
          {i18n.t('clear')}
        </Button>
        <Button
          disabled={!canSave}
          flex={1}
          onPress={handleSave}
          size="$lg"
          variant="primary"
        >
          {i18n.t('save')}
        </Button>
      </ModalSheet.Footer>
    </ModalSheet>
  );
};
